var React = require('react');

function ChevronWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m2.32290076-.91755725 1.4-1.40534351 6 6.02290076-6 6.02290076-1.4-1.40534351 4.6-4.61755725z","fill":"#fff","fillRule":"evenodd","transform":"matrix(0 1 -1 0 9.722901 -2.322901)"}));
}

ChevronWhite.defaultProps = {"height":"8","viewBox":"0 0 12 8","width":"12"};

module.exports = ChevronWhite;

ChevronWhite.default = ChevronWhite;
